var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.user)?_c('a',{attrs:{"href":`/user/${_vm.user.userId}`,"rel":"noopener"}},[_vm._v(_vm._s(_vm.userName))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }